/* istanbul ignore file */
export * from './SearchResultPageLoadingFallback';
